module.exports = __webpack_public_path__ + "static/media/Stream.11077ff5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/Stream.svg
// module id = 188
// module chunks = 0